module.exports = __webpack_public_path__ + "img/dash-circle-fill.2e1c196b.svg";